export default __webpack_public_path__ + "static/N0265-3e6f9185204e50581573105fcbc976af.png";